export const Home = ()=> {
    return (
      <main className="container page" >
        <h2>Home Page</h2>
      </main>
    );
}

export const Processes =()=> {
    return (
      <main className="container page" >
        <h2>Processes test Page</h2>
      </main>
    );
}
export const QualityControl = ()=> {
    return (
      <main className="container page" >
        <h2>Quality Control Page</h2>
      </main>
    );
}